module.exports = __webpack_public_path__ + "static/kirti-kalla-JRhvllDBhzs-unsplash-a62440ad7006ee583acb0490d1efa999.png";